import { useLanguage } from "@/context/LanguageContext";

function Star() {
  return (
    <svg viewBox="0 0 24 24" className="h-3 w-3 shrink-0 fill-[#F5C518]" aria-hidden="true">
      <path d="M12 0 L14.5 9.5 L24 12 L14.5 14.5 L12 24 L9.5 14.5 L0 12 L9.5 9.5 Z" />
    </svg>
  );
}

export default function Marquee() {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div className="overflow-hidden border-y border-white/5 bg-[#0A0D14] py-4" data-testid="marquee-strip">
      <div className="animate-marquee flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.25em] text-slate-500">
                  {item}
                </span>
                <Star />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
